import {FullHeightProductTileBase} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {ProductTile, ProductTileProps} from './ProductTile';

export const FullHeightProductTile: React.FC<
  Omit<ProductTileProps, 'ProductTileComponent'>
> = props => {
  return (
    <StyledProductTile
      {...props}
      ProductTileComponent={FullHeightProductTileBase}
    />
  );
};

const StyledProductTile = styled(ProductTile)`
  height: 100%;
  height: stretch;
`;
